import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, createElement, Fragment, useMemo, } from 'react';
import { styles as nodeStyles } from '../renderers/node/nodeStyles';
import { getCachedTokenSize } from '../utils/text/tokenMeasureCache/tokenMeasureCache';
import { _parseBreak, TextBreak } from './textBreak';
import { _parseEllipsis, TextEllipsis, } from './textEllipsis';
import { textStyles } from './textStyles';
export function TextContent(props) {
    const { children, maxLines = 10, lineGap = 0, width = nodeStyles._content.width, style = textStyles.normal, offset: initOffset = { x: 0, y: 0 }, } = props;
    const text = useMemo(() => {
        if (!children) {
            return [];
        }
        const state = { lines: 0 };
        const offset = Object.assign({}, initOffset);
        const parseChildren = (child, index) => {
            if (!child || state.lines >= maxLines) {
                return createElement(Fragment);
            }
            if (child.type === Fragment) {
                const { props: { children }, } = child;
                return cloneElement(child, { key: index }, Children.map(children, parseChildren));
            }
            const { props } = child;
            const { offset: childOffset } = props;
            const singleSpaceWidth = Math.max(getCachedTokenSize(' ', props).width | 0, 4);
            const baseParserProps = {
                singleSpaceWidth,
                width,
                style,
            };
            offset.x += (childOffset === null || childOffset === void 0 ? void 0 : childOffset.x) || 0;
            offset.y += (childOffset === null || childOffset === void 0 ? void 0 : childOffset.y) || 0;
            if (child.type === TextEllipsis) {
                const { children, height, lines } = _parseEllipsis(child, Object.assign(Object.assign({}, baseParserProps), { offset }));
                offset.y = height + lineGap;
                state.lines += lines;
                return createElement(Fragment, null, children);
            }
            if (child.type === TextBreak) {
                const { props } = child;
                const { lineGap: childLineGap = lineGap } = props;
                const { children, height, lines } = _parseBreak(child, Object.assign(Object.assign({ maxLines: maxLines - state.lines, lineGap: childLineGap }, baseParserProps), { offset }));
                offset.y = height + childLineGap;
                state.lines += lines;
                return createElement(Fragment, null, children);
            }
            return cloneElement(child);
        };
        const childrenWithOffset = Children.map(children, parseChildren);
        return childrenWithOffset;
    }, [style, children, width, lineGap, maxLines, initOffset]);
    return _jsx(_Fragment, { children: text });
}
